/**
//  * @var $ jQuery
 */

// Full Height...
// function fsHeight() {
//     let winHeight = $(window).height();
//     $('[data-height="viewport"]').css('height', winHeight, '!important');
//     $('[data-min-height="viewport"]').css('minHeight', winHeight, '!important');
// }

/* Window Load ---------------------- */

// $(window).on('load', function () {

//     setTimeout(function () {
//         $('body').addClass('loaded');
//     }, 400);

//     setTimeout(function () {
//         AOS.init({
//             once: true,
//             duration: 1000
//         });
//     }, 800);

// });


/* Document Ready ---------------------- */

// $(document).ready(function () {

//     fsHeight();


//     // Inline background image...
//     $("[data-bg]").each(function () {
//         const image = $(this).attr("data-bg");
//         $(this).css({
//             backgroundImage: 'url("' + image + '")',
//         });
//     });

// });


var swiper = new Swiper(".mySwiper", {
  spaceBetween: 30,
  cssMode: false,
  mousewheel: false,
  keyboard: true,
  grabCursor: true,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  simulateTouch: true,
  touchEventsTarget: "container",

  breakpoints: {
    0: {          
      slidesPerView: 1.5,   // ✅ Full first + 20% next
      spaceBetween: 15
    },
    768: {       
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {      
      slidesPerView: 3,
      spaceBetween: 30
    }
  }
});


const featureSwiper = new Swiper('.featureSwiper', {
  slidesPerView: 2,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    0: { slidesPerView: 1 },
    576: { slidesPerView: 2 },
    768: { slidesPerView: 2 },
    992: { slidesPerView: 2 },
  },
});


const mainImage = document.querySelector('.feature-image img');
const thumbs = document.querySelectorAll('.featureSwiper .swiper-slide');

thumbs.forEach(slide => {
  slide.addEventListener('click', function () {
    const newImg = this.querySelector('img').getAttribute('data-full');
    mainImage.src = newImg;

    thumbs.forEach(s => s.classList.remove('active-thumb'));
    this.classList.add('active-thumb');
  });
});



var swiper = new Swiper(".mySwiper1", {
  spaceBetween: 30,
  cssMode: true,
  mousewheel: false,
  keyboard: true,
  grabCursor: true,   // <-- shows hand cursor on hover

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  simulateTouch: true, // Enable mouse drag
  touchEventsTarget: "container", 

  breakpoints: {
    0: {          
      slidesPerView: 1.5,
      spaceBetween: 10,
    },
    768: {       
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {      
      slidesPerView: 3,
      spaceBetween: 30,
    }
  }
});


var swiper = new Swiper(".mySwiper3", {
  spaceBetween: 30,
  cssMode: true,
  mousewheel: false,
  keyboard: true,
  grabCursor: true,   // <-- shows hand cursor on hover

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  simulateTouch: true, // Enable mouse drag
  touchEventsTarget: "container", 

  breakpoints: {
    0: {          
      slidesPerView: 1,
    },
    768: {       
      slidesPerView: 2,
    },
    1024: {      
      slidesPerView: 3,
    }
  }
});


var swiper = new Swiper(".mySwiper2", {
  spaceBetween: 30,
  cssMode: true,
  mousewheel: false,
  keyboard: true,
  grabCursor: true,   // <-- shows hand cursor on hover

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  simulateTouch: true, // Enable mouse drag
  touchEventsTarget: "container", 

  breakpoints: {
    0: {          
      slidesPerView: 1.2,   // ✅ Full first + 20% next
      spaceBetween: 15
    },
    768: {       
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {      
      slidesPerView: 3,
      spaceBetween: 30
    }
  }
});



// ===============================
// MOBILE NAVBAR SCRIPT
// Runs only on screens < 576px
// ===============================

document.addEventListener('DOMContentLoaded', function () {

  if (!window.matchMedia('(max-width: 575px)').matches) return;

  const toggler = document.querySelector('.navbar-toggler');
  const dropdown = document.querySelector('.dropdown-menu');

  // Hamburger click
  toggler.addEventListener('click', function(e) {
    e.stopPropagation();
    this.classList.toggle('open');
    dropdown.classList.toggle('show');
  });

  // Submenu toggle
  document.querySelectorAll('.has-submenu > a').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const parentItem = this.parentElement;

      // Close other submenus
      dropdown.querySelectorAll('.has-submenu').forEach(item => {
        if (item !== parentItem) item.classList.remove('open');
      });

      // Toggle current submenu
      parentItem.classList.toggle('open');
    });
  });

  // Close main dropdown on outside click
  document.addEventListener('click', function(e) {
    if (!dropdown.contains(e.target) && !toggler.contains(e.target)) {
      dropdown.classList.remove('show');
      toggler.classList.remove('open');
      dropdown.querySelectorAll('.has-submenu').forEach(item => item.classList.remove('open'));
    }
  });

  // Close dropdown when real link clicked
  dropdown.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', function() {
      if (!this.closest('.has-submenu') || this.closest('.submenu')) {
        dropdown.classList.remove('show');
        toggler.classList.remove('open');
        dropdown.querySelectorAll('.has-submenu').forEach(item => item.classList.remove('open'));
      }
    });
  });

  // Prevent Bootstrap close on form elements
  document.querySelectorAll('.dropdown-menu').forEach(menu => {
    menu.addEventListener('click', function (e) {
      if (
        e.target.closest('input') ||
        e.target.closest('label') ||
        e.target.closest('select') ||
        e.target.closest('textarea') ||
        e.target.closest('.form-check')
      ) {
        e.stopPropagation();
      }
    });
  });

  // Bootstrap tooltips
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    new bootstrap.Tooltip(el);
  });

});


// ===============================
// DESKTOP NAVBAR SCRIPT
// Runs only on screens ≥ 576px
// ===============================
document.addEventListener('DOMContentLoaded', function () {

  if (!window.matchMedia('(min-width: 576px)').matches) return;

  const toggler = document.querySelector('.navbar-toggler');
  const dropdown = document.querySelector('.dropdown');
  const dropdownMenu = dropdown.querySelector('.dropdown-menu');
  const submenuLinks = document.querySelectorAll('.has-submenu > a');

  // Hamburger toggle
  toggler.addEventListener('click', e => {
    e.stopPropagation();
    toggler.classList.toggle('open');
    dropdown.classList.toggle('show');
  });

  // Desktop hover behavior
  document.querySelectorAll('.has-submenu').forEach(item => {
    item.addEventListener('mouseenter', () => {
      item.classList.add('open');
    });
    item.addEventListener('mouseleave', () => {
      item.classList.remove('open');
    });
  });

  // Close dropdown on outside click
  document.addEventListener('click', e => {
    if (!dropdown.contains(e.target) && !toggler.contains(e.target)) {
      dropdown.classList.remove('show');
      toggler.classList.remove('open');
      dropdown.querySelectorAll('.has-submenu').forEach(item =>
        item.classList.remove('open')
      );
    }
  });


// Close when has-submenu link clicked
dropdownMenu.addEventListener('click', e => {
  const link = e.target.closest('.has-submenu > a');
  if (!link) return;

  dropdown.classList.remove('show');
  toggler.classList.remove('open');

  dropdown.querySelectorAll('.has-submenu').forEach(item =>
    item.classList.remove('open')
  );
});

// Close when no-has-submenu link clicked
dropdownMenu.addEventListener('click', e => {
  const link = e.target.closest('.no-has-submenu > a');
  if (!link) return;
  
  dropdown.classList.remove('show');
  toggler.classList.remove('open');

  dropdown.querySelectorAll('.no-has-submenu').forEach(item =>
    item.classList.remove('open')
  );
});

  // Close when submenu link clicked
  dropdownMenu.addEventListener('click', e => {
    const link = e.target.closest('.submenu a');
    if (!link) return;

    dropdown.classList.remove('show');
    toggler.classList.remove('open');
    dropdown.querySelectorAll('.has-submenu').forEach(item =>
      item.classList.remove('open')
    );
  });



  // Prevent Bootstrap close on form elements
  document.querySelectorAll('.dropdown-menu').forEach(menu => {
    menu.addEventListener('click', function (e) {
      if (
        e.target.closest('input') ||
        e.target.closest('label') ||
        e.target.closest('select') ||
        e.target.closest('textarea') ||
        e.target.closest('.form-check')
      ) {
        e.stopPropagation();
      }
    });
  });

  // Bootstrap tooltips
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    new bootstrap.Tooltip(el);
  });

});
